// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.image__Artists_ktJ2e {\n  min-height: 150px;\n}\n", ""]);
// Exports
exports.locals = {
	"image": "image__Artists_ktJ2e"
};
module.exports = exports;
